export default ({ $sitewideData, $integrationsManager }) => {
    const clientId = $sitewideData.config.paypalClientId

    // Braintree client/checkout
    const braintree = new $integrationsManager.loaders.OnDemandLoader([
        {
            src: 'https://js.braintreegateway.com/web/3.68.0/js/client.min.js',
        },
        {
            src: 'https://js.braintreegateway.com/web/3.68.0/js/paypal-checkout.min.js',
        },
    ])

    // Paypal buttons and messaging
    const display = new $integrationsManager.loaders.OnDemandLoader([
        {
            src: `https://www.paypal.com/sdk/js?client-id=${clientId}&components=buttons,messages&disable-funding=card`,
        },
    ])

    return {
        braintree,
        display,
    }
}
